<template>
  <div>
    <div class="content-header">
      <ol class="breadcrumb">
        <li class="active">优惠券管理</li>
      </ol>
    </div>
    <div class="content-query content-border">
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item>
          <el-button class="btn btn-primary" type="primary" size="small" icon="el-icon-search"
                     @click="submitQuery(1)">刷新
          </el-button>
          <el-button type="primary" size="small" @click="openCoupon()">添加
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <hr/>
    <div class="title">
      <span>优惠券列表</span>
    </div>
    <div class="content-data" v-if="coupons && 0 < coupons.length">
      <el-table highlight-current-row :data="coupons" border ref="multipleTable">
        <el-table-column align="center" type="index"/>
        <el-table-column align="center" label="优惠券名称" prop="name"/>
        <el-table-column align="center" label="积累发放金额" prop="fullMoney"/>
        <el-table-column align="center" label="描述">
          <template slot-scope="scope">
            {{ scope.row.remark }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="优惠券状态">
          <template slot-scope="scope">
            <span>{{ couponStatuesMap[scope.row.status] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="渠道">
          <template slot-scope="scope">
            <span>{{ couponChannelsMap[scope.row.channel] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="类型">
          <template slot-scope="scope">
            <span>{{ couponTypesMap[scope.row.type] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="使用规则">
          <template slot-scope="scope">
            <span>满{{ scope.row.miniPayMoney }}减{{ scope.row.offsetMoney }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fixed="right" label="操作">
          <template slot-scope="scope">
            <p>
              <el-button type="primary" size="mini" round
                         @click="$router.push({name:'couponMemberList',query:{couponId:scope.row.id}})">查看优惠券发放记录
              </el-button>
            </p>
            <p>
              <el-button type="primary" size="mini" round
                         @click="openCoupon(scope.row.id)">
                详情
              </el-button>
              <el-tooltip v-if="'ENABLE'===scope.row.status" content="禁用后用户将不能使用" placement="top"
                          effect="light">
                <el-button type="danger" size="mini" round
                           @click="disableCoupon(scope.row.id,'DISABLE')">
                  全场禁用
                </el-button>
              </el-tooltip>
              <el-tooltip v-else content="取消禁用" placement="top"
                          effect="light">
                <el-button type="success" size="mini" round
                           @click="disableCoupon(scope.row.id,'ENABLE')">
                  取消禁用
                </el-button>
              </el-tooltip>
            </p>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="content-data" v-else>
      没有查询到数据
    </div>
    <vue-pager v-bind:datafile="fillData" url="/coupon/pageCoupon" v-bind:query="query" ref="pager"
               v-bind:init="true"></vue-pager>
    <create-coupon ref="create-coupon" @success="submitQuery(1)"/>
  </div>
</template>
<script>
import createCoupon from '@/views/coupon/components/create-coupon.vue'

export default {
  components: {
    createCoupon
  },
  data() {
    return {
      coupons: [],
      query: {},
      couponStatues: [],
      couponStatuesMap: {},

      couponChannels: [],
      couponChannelsMap: {},

      couponTypes: [],
      couponTypesMap: {},

    }
  },
  created() {
    var _this = this;

    _this.couponTypes = _this.$common.enum_config('ECouponType');
    _this.couponTypes.forEach((item) => {
      _this.couponTypesMap[item.name] = item.label;
    });
    _this.couponStatues = _this.$common.enum_config('ECouponStatus');
    _this.couponStatues.forEach((item) => {
      _this.couponStatuesMap[item.name] = item.label;
    });
    _this.couponChannels = _this.$common.enum_config('ECouponChannel');
    _this.couponChannels.forEach((item) => {
      _this.couponChannelsMap[item.name] = item.label;
    });
  },
  methods: {
    openCoupon(_couponId) {
      this.$refs["create-coupon"].openDialog(_couponId)
    },
    fillData(_response) {
      const _this = this;
      _this.coupons = _response.items || [];
    },
    submitQuery(_num) {
      const _this = this;
      _this.coupons = [];
      _this.$refs.pager.gotoPage(_num);
    },
    disableCoupon(_couponId, _status) {
      const _this = this;
      _this.$common.my_ajax({
        url: '/coupon/disableCoupon',
        data: {
          couponId: _couponId,
          status: _status
        },
        success: function (response) {
          _this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1000,
            onClose: function () {
              _this.submitQuery();
            }
          });
        }
      });
    },
    deleteCoupon: function (_tagId) {
      const _this = this;
      _this.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$common.my_ajax({
          url: '/tag/deleteTag',
          data: {
            tagId: _tagId
          },
          success: function (response) {
            _this.$message({
              message: '删除成功',
              type: 'success',
              duration: 1000,
              onClose: function () {
                _this.submitQuery();
              }
            });
          }
        });
      }).catch(() => {
        console.log('取消删除');
      });
    }
  },
}
</script>
<style>

</style>
